// extracted by mini-css-extract-plugin
export default {"btnContainer":"Players_btnContainer__BmZw9"};